<script setup lang="ts">
type Props = {
  text: string
}
defineProps<Props>()

const paymentInfo = ref<HTMLDivElement | null>(null)
</script>

<template>
  <div ref="paymentInfo" class="payment-info" v-html="text" />
</template>

<style lang="scss" scoped>
.payment-info {
  font-size: 14px;

  :deep(h4) {
    margin-top: 30px;
    font-size: 14px;
    @include media('>=tablet') {
      font-size: 20px;
    }
    @include media('>=desktop-mini') {
      font-size: 20px;
    }
  }

  :deep(h5) {
    margin-top: 20px;
    font-size: 12px;
    font-weight: bold;
    @include media('>=tablet') {
      margin-top: 30px;
      font-size: 14px;
    }
    @include media('>=desktop-mini') {
      margin-top: 30px;
      font-size: 14px;
    }
  }

  :deep(p) {
    margin-top: 10px;
    margin-bottom: 0;
    font-size: 12px;
    @include media('>=tablet') {
      margin-top: 20px;
      font-size: 14px;
    }
    @include media('>=desktop-mini') {
      margin-top: 20px;
      font-size: 14px;
    }
  }

  :deep(a) {
    margin: 10px 0;
    font-size: 14px;
    font-weight: bold;
    text-decoration: none;
    &[href*='tel:'] {
      display: inline-block;
    }
    img {
      width: 24px;
      height: 24px;
      margin-right: 10px;
      vertical-align: middle;
    }
  }

  :deep(ul) {
    padding-left: 16px;
    margin-bottom: 16px;
    font-size: 12px;
    list-style-type: disc;
    @include media('>=tablet') {
      font-size: 14px;
      list-style-type: disc;
    }
    @include media('>=desktop-mini') {
      font-size: 14px;
      list-style-type: disc;
    }
  }

  :deep(li) {
    margin: 8px 0;
    @include media('>=tablet') {
      margin: 4px 0;
    }
  }
}
</style>
